module.exports = __webpack_public_path__ + "static/media/logo.3d5a12db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/logo.gif
// module id = 539
// module chunks = 0